import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { excluded, featureGroups, phases } from '../../data/offer';
import { Section } from './Section';
export function Scope() {
  return <>
      <Section index="05" label="Scope" title="Wat er in zit" data-id="element-81" data-mp="14iybk5i4ob9d">
        <div className="grid gap-px overflow-hidden rounded-xl border border-line bg-white/10 md:grid-cols-3" data-id="element-82" data-mp="14khs7x7p4obo">
          {featureGroups.map(group => <div key={group.title} className="bg-ink p-6" data-id="element-83" data-mp="1x856kuidiipv">
              <h3 className="text-sm font-semibold uppercase tracking-[0.14em] text-accent" data-id="element-84" data-mp="225nimtrote23">
                {group.title}
              </h3>
              <ul className="mt-4 space-y-3" data-id="element-85" data-mp="1ng7s9ew2jamx">
                {group.items.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/75" data-id="element-86" data-mp="1seswdpefyegn">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-87" data-mp="2g4wnixag0lqr" />
                    <span data-id="element-88" data-mp="2kx6m11pmiu4n">{item}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <ul className="mt-6 flex flex-wrap gap-x-8 gap-y-2" data-id="element-89" data-mp="2dtsaxlymxa30">
          {excluded.map(item => <li key={item} className="flex gap-2 text-sm text-white/40" data-id="element-90" data-mp="28v8n1g0hdo80">
              <MinusIcon className="mt-1 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-91" data-mp="2mq1e9bpqgsuf" />
              <span data-id="element-92" data-mp="2hwyf8o26sr6u">{item}</span>
            </li>)}
        </ul>
      </Section>

      <Section index="06" label="Planning" title="Live in 3 à 4 weken" data-id="element-93" data-mp="2wll5hktcr3cu">
        <ol className="grid gap-6 md:grid-cols-4" data-id="element-94" data-mp="2rntbml95d760">
          {phases.map(phase => <li key={phase.week} className="border-t border-line pt-4" data-id="element-95" data-mp="35nc6wdgv0o0w">
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-accent" data-id="element-96" data-mp="35l87o8twod6y">
                {phase.week}
              </p>
              <h3 className="mt-2 text-base font-semibold tracking-tight text-white" data-id="element-97" data-mp="1b8rsgij4topy">
                {phase.title}
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-white/55" data-id="element-98" data-mp="17914emkzpmp4">
                {phase.text}
              </p>
            </li>)}
        </ol>
      </Section>
    </>;
}